
export { CollectionName } from "/codebuild/output/src306799893/src/packages/search-document-builders/src/registry/collection-registry.ts"
export { collectionAlias } from "./registry/schema-registry"